import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es from './messages/es'
import * as validations from './validations'
import { intlLocale } from '../config'

const resources = { es: { translation: es } }

// https://react.i18next.com/getting-started

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (typeof value === 'number') {
          if (format === 'intlNumber') {
            return new Intl.NumberFormat(intlLocale).format(value)
          }
          if (format === 'intlNumberWitOneDecimal') {
            return new Intl.NumberFormat(intlLocale, { maximumFractionDigits: 1 }).format(value)
          }
          if (format === 'intlPercent') {
            return new Intl.NumberFormat(intlLocale, { style: 'percent' }).format(value)
          }
          if (format === 'intlPercentWitOneDecimal') {
            return new Intl.NumberFormat(intlLocale, { style: 'percent', minimumFractionDigits: 1 }).format(value)
          }
          if (format === 'intlCurrency') {
            if (Number.isInteger(value)) return new Intl.NumberFormat(intlLocale, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value)
            return new Intl.NumberFormat(intlLocale, { style: 'currency', currency: 'USD' }).format(value)
          }
        }
        return value
      },
    }
  })


export const currentMessageValidation = validations.es

export default i18n
